module.exports = __webpack_public_path__ + "img/ss1.35d23f22.jpg";